import React from "react";
import ReactDOM from "react-dom";
import FeaturedTeacherSection from "../components/FeaturedTeacherSection";
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderFeaturedTeacherSection = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (element) {

    initializeI18n()
      .then((i18nInstance) => {
        ReactDOM.render(<FeaturedTeacherSection props={props} />, element);
      })
      .catch(error => {
        //console.error("Failed to initialize i18n before rendering FeaturedTeacherSection:", error);
      });

  } else {
    //console.error(`Element with ID ${elementId} not found.`);
  }
};
